import { render, staticRenderFns } from "./OsTargetProfilePdfDownloadBtn.vue?vue&type=template&id=3363cf8c&scoped=true"
import script from "./OsTargetProfilePdfDownloadBtn.vue?vue&type=script&lang=ts"
export * from "./OsTargetProfilePdfDownloadBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363cf8c",
  null
  
)

export default component.exports